module.exports = __webpack_public_path__ + "static/media/wizualizacja-4.9ef19dad.png";